import React from "react";
import './Nav.css';
import { Link } from 'react-router-dom';

function Nav() {

    return (
        <div>
        <nav>
            <Link className="nav-buttons-logo" to="/">
                <h3>ATK Applications</h3>
             </Link>
            <u1 className="nav-links">
                <Link className="nav-buttons" to="/software">
                    <li>Software</li>
                </Link>

                <Link className="nav-buttons" to="/about">
                    <li>About</li>
                </Link>

                <Link className="nav-buttons" to="/contact">
                    <li>Contact</li>
                </Link>
            </u1>
        </nav>
        </div>
    );
}

export default Nav;